import api from "@/services/api";

export default {
  getDiagnosesList() {
    return api.get("get_diagnoses_list/").then((response) => response.data);
  },
  getShortenDiagnoses() {
    return api.get("get_shorten_diagnoses/").then((response) => response.data);
  },
  getDiagnosesGroupedList() {
    return api
      .get("get_diagnoses_grouped_list/")
      .then((response) => response.data);
  },
  getGradeLevelsRenames(schoolID) {
    return api
      .get(`schools/${schoolID}/get_levels_renames/`)
      .then((response) => response.data);
  },
  getPieGrades() {
    return api.get("get_grades_list/").then((response) => response.data);
  },
  getSubjects() {
    return api.get("get_subjects_list/").then((response) => response.data);
  },
  getCountries() {
    return api.get("get_countries/").then((response) => response.data);
  },
  getUsers() {
    return api.get("get_users/").then((response) => response.data);
  },
  getRoles() {
    return api.get("get_roles/").then((response) => response.data);
  },
  getMaterialsRoles() {
    return api.get("get_materials_roles/").then((response) => response.data);
  },
  getRegions(country) {
    return api.get(`get_regions/${country}/`).then((response) => response.data);
  },
  getCardSubjects() {
    return api.get(`get_card_subjects/`).then((response) => response.data);
  },
  getCardSubjectsValues() {
    return api
      .get(`get_card_subjects_values/`)
      .then((response) => response.data);
  },
  getCardSpecialSubjectsValues() {
    return api
      .get(`get_card_special_subjects_values/`)
      .then((response) => response.data);
  },
  getCardGrades() {
    return api.get(`get_card_grades/`).then((response) => response.data);
  },
  ping() {
    return api.get("ping/").then((response) => response.data);
  },
  download_sige_template() {
    return api
      .post("download_sige_template/", {}, { responseType: "blob" })
      .then((response) => response);
  },
  getEjesValues(subject, materialKind, level) {
    return api
      .get(`get_ejes/?subject=${subject}&material_kind=${materialKind}&level=${level}`)
      .then((response) => response.data);
  },
  getEjesWithLevels(subject) {
    return api
      .get(`get_ejes_with_levels/?subject=${subject}`)
      .then((response) => response.data);
  },
  // El contenido de la pagina /<servicio>/ (backend/marketing/pages.py):
  // resumen, pasos, cifras, preguntas frecuentes y planes. Lo consumen los
  // chatbots demo para no ser una segunda copia de esa pagina — sobre todo del
  // precio, que ahi vive una sola vez y a proposito.
  getServiceContent(service) {
    return api
      .get(`marketing/service/${service}/`)
      .then((response) => response.data);
  },
  // El marcado, la hoja del producto y la paleta de la simulación de
  // planificaciones (backend/marketing/views.vivo_planificacion). El SPA lo
  // monta en un shadow root: ver PlanificationVivo.vue.
  getVivoPlanificacion() {
    return api
      .get("marketing/demo/planificacion/")
      .then((response) => response.data);
  },
  // El cuerpo de /pruebas-de-especialidad/ —marcado, hojas y
  // paleta— para montarlo en un shadow root: ver PruebasSecciones.vue.
  getPruebasSecciones() {
    return api
      .get("marketing/demo/pruebas/")
      .then((response) => response.data);
  },
  // El cuerpo de /documentacion-pie/ —marcado, hojas y paleta—
  // para montarlo en un shadow root: ver DocumentacionSecciones.vue.
  getDocumentacionSecciones() {
    return api
      .get("marketing/demo/documentacion/")
      .then((response) => response.data);
  },
  // El cuerpo de /correccion-de-tests/ —marcado, hojas y paleta—
  // para montarlo en un shadow root: ver CorreccionSecciones.vue.
  getCorreccionSecciones() {
    return api
      .get("marketing/demo/correccion/")
      .then((response) => response.data);
  },
  // La portada de la app —marcado, hoja y paleta— para montarla en un
  // shadow root: ver LandingPage.vue y landingEngine.js.
  getLanding() {
    return api.get("marketing/landing/").then((response) => response.data);
  },
  // El formulario de contacto de la portada: { subject, message }.
  sendEmail(payload) {
    return api.post("send_email/", payload);
  },
  sendEurekaBill(payload) {
    return api
      .post("send_eureka_bill/", payload)
      .then((response) => response.data);
  },
  getEurekaManual() {
    return api.get("get_eureka_instructive/").then((response) => response.data);
  },
  // Premios de una cuenta nueva por servicio; endpoint anónimo, lo usan las
  // vistas demo.
  getSignupRewards(service) {
    return api
      .get(`signup_rewards/?service=${encodeURIComponent(service)}`)
      .then((response) => response.data);
  },
  getPieStatusChoices() {
    return api.get("get_pie_status_choices/").then((response) => response.data);
  },
};
